var __jsx = React.createElement;
import React, { useCallback } from 'react';
import { Map as MapComponent } from '@vis.gl/react-google-maps';
import styled from 'styled-components';
import styles from './Map.style.js';
import { ClusteredLocationMarkers } from './ClusteredLocationMarkers';
function Map(_ref) {
  var className = _ref.className,
    locations = _ref.locations,
    mapId = _ref.mapId,
    isLoadingLocations = _ref.isLoadingLocations,
    selectedLocation = _ref.selectedLocation,
    handleSelectLocation = _ref.handleSelectLocation,
    defaultMap = _ref.defaultMap,
    selectedLocationKey = _ref.selectedLocationKey,
    setSelectedLocationKey = _ref.setSelectedLocationKey;
  return __jsx("div", {
    className: "nva-map ".concat(className)
  }, __jsx(MapComponent, {
    mapId: mapId,
    defaultCenter: defaultMap.CENTER,
    defaultZoom: defaultMap.ZOOM,
    gestureHandling: "cooperative",
    disableDefaultUI: true,
    zoomControl: true,
    streetViewControl: true
  }, locations && __jsx(ClusteredLocationMarkers, {
    locations: locations,
    isLoadingLocations: isLoadingLocations,
    handleSelectLocation: handleSelectLocation,
    selectedLocationKey: selectedLocationKey,
    setSelectedLocationKey: setSelectedLocationKey,
    hasOldIcons: true
  }, __jsx(ClusteredLocationMarkers.OldInfoWindow, {
    selectedLocation: selectedLocation
  }))));
}
export default styled( /*#__PURE__*/React.memo(Map)).withConfig({
  componentId: "sc-1ns5p3y-0"
})(["", ";"], styles);